'use client'

import { Suspense, useEffect, useRef, type ReactNode } from 'react'
import { usePathname, useSearchParams } from 'next/navigation'
import posthog from 'posthog-js'

let isPostHogInitialized = false

function PostHogInit() {
  const pathname = usePathname()
  const initializedRef = useRef(false)

  useEffect(() => {
    const initDelay = pathname?.startsWith('/consultation') ? 0 : 3000

    const timer = window.setTimeout(() => {
      if (initializedRef.current) return
      initializedRef.current = true
      isPostHogInitialized = true

      posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY as string, {
        api_host: '/ingest',
        ui_host: 'https://us.posthog.com',
        person_profiles: 'identified_only',
        autocapture: false,
        capture_pageview: false,
        capture_pageleave: true,
        session_recording: {
          maskAllInputs: true,
          maskTextSelector: '[data-ph-mask]',
        },
      })

      posthog.register_once({
        initial_referrer: document.referrer || '$direct',
        initial_landing_page: window.location.pathname,
      })
    }, initDelay)
    return () => window.clearTimeout(timer)
  }, [pathname])

  return null
}

function PostHogPageview() {
  const pathname = usePathname()
  const searchParams = useSearchParams()

  useEffect(() => {
    if (!isPostHogInitialized) return
    const url = pathname + (searchParams?.toString() ? `?${searchParams.toString()}` : '')
    posthog.capture('$pageview', { $current_url: url })
  }, [pathname, searchParams])

  return null
}

export function PHProvider({ children }: { children: ReactNode }) {
  return (
    <>
      <PostHogInit />
      <Suspense fallback={null}>
        <PostHogPageview />
      </Suspense>
      {children}
    </>
  )
}
